import { Component } from "react";
import {Container} from "reactstrap";
import NavTab from "../../../components/common/global_layout/navTab";
import '../../../style/css/particulier/hebergement.css'
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import AnnounceRow from "../../../components/common/announceRow";
import { viaPay } from "../../../slices/modalSlice";

class Mon_panier_voyage extends Component {
    
  constructor(props) {
    super(props);
    this.state = { 
      prixTotal : "",
      panierNumber : ""
   }

    this.toggle = this.viaPay.bind(this);
 

  }
  

  viaPay = () => this.props.dispatch(viaPay())


    render() { 
        

      
        return (
          <>
            <Container>
              <NavTab display="none" />
              <center>
                <h3 className="title-70 mt-4">J'Organise mon Voyage Omra</h3>
              </center>
              <div className="panier__content mx-3">
      
                    
                    <div className="panier__header d-flex">
                       <img src="/imgs/navebar/shopingIcon.svg" className="basket-icon-nvTab" alt="shopingIcon" />
                       <h3 className="panier__header__txt">Mon Panier (4)</h3>
                    </div>
                    <div className="panier__container">
                        <form>
                          <div class="form-group-panier d-flex flex-row align-items-center justify-content-between">
                            <input type="checkbox" id="id1" />
                
                            <label for="id1">
                      
                            </label>
                            <AnnounceRow 
                            img="/imgs/announces/index.png"
                            imgWidth="25%"
                            title="Vol Omra - Titre de l'offre"
                            description="Hello word"
                            prix="12 000"
                            promotion
                            contact
                            deleteItem
                            />
                        
                          </div>

                          <div class="form-group-panier d-flex flex-row align-items-center justify-content-between">
                            <input type="checkbox" id="id2" />
                
                            <label for="id2">
                      
                            </label>
                            <AnnounceRow 
                            img="/imgs/announces/index.png"
                            imgWidth="25%"
                            title="Vol Omra - Titre de l'offre"
                            description="Hello word"
                            prix="12 000"
                            promotion
                            contact
                            deleteItem
                            />
                          </div>

                          <div class="form-group-panier d-flex flex-row align-items-center justify-content-between">
                            <input type="checkbox" id="id3" />
                
                            <label for="id3">
                      
                            </label>
                            <AnnounceRow 
                            img="/imgs/announces/index.png"
                            imgWidth="25%"
                            title="Vol Omra - Titre de l'offre"
                            description="Hello word"
                            prix="12 000"
                            promotion
                            contact
                            deleteItem
                            />
                          </div>

                          <div class="form-group-panier d-flex flex-row align-items-center justify-content-between">
                            <input type="checkbox" id="id4" />
                
                            <label for="id4">
                      
                            </label>
                            <AnnounceRow 
                            img="/imgs/announces/index.png"
                            imgWidth="25%"
                            title="Vol Omra - Titre de l'offre"
                            description="Hello word"
                            prix="12 000"
                            promotion
                            contact
                            deleteItem
                            />
                          </div>

                          <div class="form-group-panier d-flex flex-row align-items-center justify-content-between">
                            <input type="checkbox" id="id5" />
                
                            <label for="id5">
                      
                            </label>
                            <AnnounceRow 
                            img="/imgs/announces/index.png"
                            imgWidth="25%"
                            title="Vol Omra - Titre de l'offre"
                            description="Hello word"
                            prix="12 000"
                            promotion
                            contact
                            deleteItem
                            />
                          </div>

                          <div class="form-group-panier d-flex flex-row align-items-center justify-content-between">
                            <input type="checkbox" id="id6" />
                
                            <label for="id6">
                      
                            </label>
                            <AnnounceRow 
                            img="/imgs/announces/index.png"
                            imgWidth="25%"
                            title="Vol Omra - Titre de l'offre"
                            description="Hello word"
                            prix="12 000"
                            promotion
                            contact
                            deleteItem
                            />
                          </div>
                        
                          
                      </form>
                       
                    </div>
                    <div className="panier__total d-flex justify-content-end mt-3 mr-4">
                      <h4 className="panier__total__txt">Total  :   <span className="panier__total__prix">130000</span> DZD</h4>
                    </div>
                    <div className="panier__paiement d-flex flex-column align-items-center">
                       <button className="panier__paiement__btn" onClick={this.viaPay}>Procéder au paiement</button>
                    </div>
            </div>
            </Container>
          </>
        );
    }
}
 
function mapStateToProps(state) {
  return {
    /*
    reserve: state.counterApp.reserve,
    */
    
  }
}
export default withRouter(connect(mapStateToProps)(Mon_panier_voyage));
